module.exports = __webpack_public_path__ + "html/project-buttons_71a8fe567ac104b59b050ed8516b9019.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-buttons.html
// module id = vhpm
// module chunks = 51